<template>
  <div class="banner-container clearFix" style="margin:0 auto;">
    <div class="by-content">
      <el-carousel indicator-position="outside" :interval="10000" :autoplay="false">
        <el-carousel-item v-for="item in carousels" :key="item.src">
          <a><img v-bind:src="item.src" alt /></a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="by-content by-content-top clearFix">
      <div class="by-content-left fl">
        <el-tabs type="border-card">
          <el-tab-pane>
            <span slot="label" class="bg-line-title">线路发货</span>
            <div class="el-content-left fl">
              <div>
                发货地:
                <el-cascader placeholder="请选择所在省市" class="el-select-width-500" :clearable="true" :options="regions" v-model="statecitys" filterable></el-cascader>
              </div>
              <div>
                收货地:
                <el-select placeholder="请选择收货国家" class="el-select-width-500"></el-select>
              </div>
            </div>
            <div class="el-content-right fr">
              <el-button type="primary" class="el-button-search">查询</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label" class="bg-branches-title">网点查询</span>
            <div class="el-content-left fl">
              <div>
                地区:
                <el-cascader placeholder="请选择地区" class="el-select-width-500" :clearable="true" :options="regions" v-model="statecitys" filterable></el-cascader>
              </div>
              <div>
                街道:
                <el-input placeholder="请填写附近街道" class="el-select-width-500"></el-input>
              </div>
            </div>
            <div class="el-content-right fr">
              <el-button type="primary" class="el-button-search">查询</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label" class="bg-tracking-title">物流追踪</span>
            <div class="el-content-left fl">
              <div>
                物流公司:
                <el-select placeholder="请选择物流公司" class="el-select-width-500"></el-select>
              </div>
              <div>
                承运单号:
                <el-input placeholder="请输入完整承运单号" class="el-select-width-500"></el-input>
              </div>
            </div>
            <div class="el-content-right fr">
              <el-button type="primary" class="el-button-search">查询</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="by-content-right fr">
        <el-tabs type="border-card">
          <el-tab-pane>
            <span slot="label" class="bg-ec-title">电商</span>
            线路发货</el-tab-pane>
          <el-tab-pane>
            <span slot="label" class="bg-tm-title">物流</span>
            物流
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label" class="bg-wm-title">仓储</span>
            功能待开放
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="by-content clearFix">
      <div class="by-content-left by-content-lines by-content-white fl">
        <div class="hot-lines">
          <div class="hot-lines-title fl">
            热门线路
            <span class="hot-lines-title-span">Hot Lines</span>
          </div>
          <div class="hot-lines-more fr">
            <router-link tag="a" :to="{name:'index'}">
              <img src="/static/home/line-48-48.svg" class="hot-lines-more-img" alt="">
              <span>全部线路</span>
            </router-link>
          </div>
          <div class="clear"></div>
          <div class="hot-line-content">
            <div class="hot-line fl">
              <div class="hot-line-content">
                <div class="fl"><span class="title-lable">物流商：</span><span class="title-content">中国邮政</span></div>
                <div class="fr"><img src="/static/home/pick-60-32.png" alt /><img src="/static/home/send-60-32.png" alt /></div>
                <div class="clear"></div>
                <div class="starting">
                  广州 <span><span></span>发往<span></span></span> 美国
                </div>
                <div class="price-list">
                  <div class="fl">
                    <div>
                      重货:<span class="red">2.05</span><span class="holine">2.41</span><span>元/千克</span>
                    </div>
                    <div>
                      轻货:<span class="red">430</span><span class="holine">506</span><span>元/立方</span>
                    </div>
                  </div>
                  <div class="fr">
                    <label>8.5折</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="hot-line fl">
              <div class="hot-line-content">
                <div class="fl"><span class="title-lable">物流商：</span><span class="title-content">中国邮政</span></div>
                <div class="fr"><img src="/static/home/pick-60-32.png" alt /><img src="/static/home/send-60-32.png" alt /></div>
                <div class="clear"></div>
                <div class="starting">
                  广州 <span><span></span>发往<span></span></span> 美国
                </div>
                <div class="price-list">
                  <div class="fl">
                    <div>
                      重货:<span class="red">2.05</span><span class="holine">2.41</span><span>元/千克</span>
                    </div>
                    <div>
                      轻货:<span class="red">430</span><span class="holine">506</span><span>元/立方</span>
                    </div>
                  </div>
                  <div class="fr">
                    <label>8.5折</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="hot-line fl">
              <div class="hot-line-content">
                <div class="fl"><span class="title-lable">物流商：</span><span class="title-content">中国邮政</span></div>
                <div class="fr"><img src="/static/home/pick-60-32.png" alt /><img src="/static/home/send-60-32.png" alt /></div>
                <div class="clear"></div>
                <div class="starting">
                  广州 <span><span></span>发往<span></span></span> 美国
                </div>
                <div class="price-list">
                  <div class="fl">
                    <div>
                      重货:<span class="red">2.05</span><span class="holine">2.41</span><span>元/千克</span>
                    </div>
                    <div>
                      轻货:<span class="red">430</span><span class="holine">506</span><span>元/立方</span>
                    </div>
                  </div>
                  <div class="fr">
                    <label>8.5折</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="hot-line fl">
              <div class="hot-line-content">
                <div class="fl"><span class="title-lable">物流商：</span><span class="title-content">中国邮政</span></div>
                <div class="fr"><img src="/static/home/pick-60-32.png" alt /><img src="/static/home/send-60-32.png" alt /></div>
                <div class="clear"></div>
                <div class="starting">
                  广州 <span><span></span>发往<span></span></span> 美国
                </div>
                <div class="price-list">
                  <div class="fl">
                    <div>
                      重货:<span class="red">2.05</span><span class="holine">2.41</span><span>元/千克</span>
                    </div>
                    <div>
                      轻货:<span class="red">430</span><span class="holine">506</span><span>元/立方</span>
                    </div>
                  </div>
                  <div class="fr">
                    <label>8.5折</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="hot-line fl">
              <div class="hot-line-content">
                <div class="fl"><span class="title-lable">物流商：</span><span class="title-content">中国邮政</span></div>
                <div class="fr"><img src="/static/home/pick-60-32.png" alt /><img src="/static/home/send-60-32.png" alt /></div>
                <div class="clear"></div>
                <div class="starting">
                  广州 <span><span></span>发往<span></span></span> 美国
                </div>
                <div class="price-list">
                  <div class="fl">
                    <div>
                      重货:<span class="red">2.05</span><span class="holine">2.41</span><span>元/千克</span>
                    </div>
                    <div>
                      轻货:<span class="red">430</span><span class="holine">506</span><span>元/立方</span>
                    </div>
                  </div>
                  <div class="fr">
                    <label>8.5折</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="hot-line fl">
              <div class="hot-line-content">
                <div class="fl"><span class="title-lable">物流商：</span><span class="title-content">中国邮政</span></div>
                <div class="fr"><img src="/static/home/pick-60-32.png" alt /><img src="/static/home/send-60-32.png" alt /></div>
                <div class="clear"></div>
                <div class="starting">
                  广州 <span><span></span>发往<span></span></span> 美国
                </div>
                <div class="price-list">
                  <div class="fl">
                    <div>
                      重货:<span class="red">2.05</span><span class="holine">2.41</span><span>元/千克</span>
                    </div>
                    <div>
                      轻货:<span class="red">430</span><span class="holine">506</span><span>元/立方</span>
                    </div>
                  </div>
                  <div class="fr">
                    <label>8.5折</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="by-content-right by-content-lines by-content-gray fr">
        <div class="dynamic">
          <div class="dynamic-title fl">
            逸天环球动态
            <span class="dynamic-title-span">NEWS</span>
          </div>
          <div class="dynamic-more fr">
            <router-link tag="a" :to="{name:'index'}">
              <img src="/static/home/more-48-48.svg" class="dynamic-more-img" alt="">
              <span>更多动态</span>
            </router-link>
          </div>
          <div class="clear"></div>
          <div class="dynamic-pic">
            <img src="/static/home/dynamic-368-142.png" alt />
          </div>
          <ul class="dynamic-content">
            <li>【优惠】物流商折扣活动-物流成本降降降!</li>
            <li>【操作】商家工作台及发货链路</li>
            <li>【规则】56首页及特惠活动页展示规则</li>
            <li>【操作】菜鸟物流秘笈，下单没烦恼！</li>
            <li>【操作】ET发货链路 -自联物流发货</li>
            <li>【操作】ET物流管理神帖</li>
            <li>【操作】如何打印发货单？</li>
            <li>【公告】2018年物流商国庆放假公告</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="by-content clearFix">
      <div class="by-content-left by-content-lines by-content-gray dv-weekstar-height fl">
        <div class="top-list">
          <div class="top-list-title">
            本周榜单
            <span class="top-list-title-span">LEADERBOARD</span>
          </div>
          <ul>
            <li class="fl">
              <div class="top-list-top">
                <img src="/static/home/weekstar-28-88.svg" class="label" alt="" />
                <img src="/static/home/weekstar-238-85.jpg" alt="" />
                <img src="/static/home/dsu-120-60.png" class="logo" alt="" />
              </div>
              <div class="top-list-content">
                <p class="title">广州DHL速递</p>
                <p class="sub-title">收派无盲区,全球全覆盖，
                  一周内派件！</p>
                <p class="content">全网型物流商</p>
                <p class="content">线路数：99980</p>
                <p class="content">网点数：9998</p>
                <p class="content">提供广州当天入仓一周内送达的物流服务</p>
              </div>
            </li>
            <li class="fl">
              <div class="top-list-top">
                <img src="/static/home/servicestar-28-88.svg" class="label" alt="" />
                <img src="/static/home/servicestar-238-85.jpg" alt="" />
                <img src="/static/home/baishi-120-60.png" class="logo" alt="" />
              </div>
              <div class="top-list-content">
                <p class="title">广州UPS速递</p>
                <p class="sub-title">收派无盲区,全球全覆盖，
                  一周内派件！</p>
                <p class="content">全网型物流商</p>
                <p class="content">线路数：99980</p>
                <p class="content">网点数：9998</p>
                <p class="content">提供广州当天入仓一周内送达的物流服务</p>
              </div>
            </li>
            <li class="fl">
              <div class="top-list-top">
                <img src="/static/home/newstar-28-70.svg" class="label" alt="" />
                <img src="/static/home/newstar-238-85.jpg" alt="" />
                <img src="/static/home/yujia-120-60.png" class="logo" alt="" />
              </div>
              <div class="top-list-content">
                <p class="title">广州E邮宝</p>
                <p class="sub-title">收派无盲区,全球全覆盖，
                  一周内派件！</p>
                <p class="content">全网型物流商</p>
                <p class="content">线路数：99980</p>
                <p class="content">网点数：9998</p>
                <p class="content">提供广州当天入仓一周内送达的物流服务</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="by-content-right by-content-lines by-content-white dv-weekstar-height fr">
        <div class="sale">
          <div class="sale-title fl">
            特惠活动
            <span class="sale-title-span">SALE</span>
          </div>
          <div class="sale-more fr">
            <router-link tag="a" :to="{name:'index'}">
              <img src="/static/home/more-48-48.svg" class="sale-more-img" alt="">
              <span>更多活动</span>
            </router-link>
          </div>
          <div class="clear"></div>
          <ul>
            <li>
              <img src="/static/home/sale-1-368-142.jpg" alt="" />
            </li>
            <li>
              <img src="/static/home/sale-2-368-142.jpg" alt="" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="by-content clearFix">
      <div class="title-box fl">
        <p class="p">逸天环球可以为您提供什么服务保障？</p>
        <span>集结众家企业货运能力,提供真实可靠的物流服务</span>
        <ul>
          <li class="fl">
            <img src="/static/home/quan-284-186.jpg" alt="" />
            <div>
              <span>全:海量运力</span>
              <p>链接上千家快运物流公司，产品囊括小包、快递、海运、空运、专线等，网络线路覆盖千万级，实现一点发全球。</p>
            </div>
          </li>
          <li class="fl">
            <img src="/static/home/sheng-284-186.jpg" alt="" />
            <div>
              <span>省:独享低价</span>
              <p>整合各家物流实力,独享物流费用议价能力,实现全网比价,在线下单即可统一管理物流订单。</p>
            </div>
          </li>
          <li class="fl">
            <img src="/static/home/jian-284-186.jpg" alt="" />
            <div>
              <span>见:物流跟踪</span>
              <p>携手17track,物流节点及时更新,货物物流跟踪全程可视,让发货方和收货方的交易因物流而变得更信任。</p>
            </div>
          </li>
          <li class="fl">
            <img src="/static/home/pei-284-186.jpg" alt="" />
            <div>
              <span>保:发货保障</span>
              <p>ET环球在线发货,服务有保障,若有异议可在线投诉,ET客服及时介入处理,让您发货无忧。</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import regions from '@/common/region'

export default {
  data () {
    return {
      statecitys: [],
      regions: regions.regions,
      carousels: [{
        src: '/static/home/carousel-1280-300-1.png',
        link: ''
      },
      {
        src: '/static/home/carousel-1280-300-2.jpg',
        link: ''
      }
      ]
    }
  }
}
</script>

<style>
@import "../../css/home/home.css";
@import "../../css/home/index.css";
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue